module.exports = __webpack_public_path__ + "static/media/next-arrow.63dd86b8.png";